import React, { useEffect, useState } from 'react';
import userProfile from '../../../assets/images/userProfile.svg';
import CustomerCall from '../../../assets/images/call.svg';
import CustomerSms from '../../../assets/images/sms.svg';
import CustomerLocation from '../../../assets/images/location.svg';
import { useSelector } from 'react-redux';
import { useHook as CustomerHook } from './useHook';
import { useLocation, useParams } from 'react-router-dom';
import { Unauthorized } from '../../../components/index';
import ReadableParameterList from './readableParameterList';
import WritableParameterList from './writableParameterList';
import EquipmentAlert from './equipmentAlert';
import EquipmentInformation from './equipmentInformation';
import { ErrorMessage } from '../../../permissionErrorMessage/PermissionMessage';
interface Props {
  pagePermissionIDs: unknown;
  setRefreshFunction: (handleRefreshClick: () => void) => void;
  collapseView: boolean;
}
const EquipmentDetails: React.FC<Props> = ({
  pagePermissionIDs,
  setRefreshFunction,
  collapseView,
}) => {
  const userRole = localStorage.getItem('role');
  const canUpdateUnitDetails =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('customers::unitDetails');

  const canCustomerlistPermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('customers::list');

  const requiredAccess = (
    <section className="required_access_section">
      <p>you require below access:</p>
      <ul>
        <li>{ErrorMessage['customers::unitDetails'] || ''}</li>
        <li>{ErrorMessage['customers::list'] || ''}</li>
      </ul>
    </section>
  );

  const {
    fetchCustomerUnitDetails,
    fetchDealerCustomerUnitDetails,
    fetchEquipmentDeatils,
    fetchDealerEquipmentDeatils,
  } = CustomerHook();
  const { id } = useParams();
  const location = useLocation();
  const stateData = location.state;
  const { customerUnitDetails } = useSelector(
    (state: any) => state.customerManagement,
  );

  const [refreshKey, setRefreshKey] = useState(0);

  //getcomstomerUnitDetails
  const getComstomerUnitDetails = async () => {
    const payload = {
      unitID: id,
      customerID: stateData?.customerId,
    };
    if (userRole === 'dealer') {
      await fetchDealerCustomerUnitDetails(payload);
    } else {
      if (canUpdateUnitDetails && canCustomerlistPermission) {
        await fetchCustomerUnitDetails(payload);
      }
    }
  };

  //getEquipmentDetails
  const getEquipmentDetails = async () => {
    if (userRole === 'dealer') {
      await fetchDealerEquipmentDeatils({ unitID: id });
    } else {
      await fetchEquipmentDeatils({ unitID: id });
    }
  };

  const getCustomerEquipmentDetails = () => {
    if (canUpdateUnitDetails && canCustomerlistPermission) {
      if (stateData?.customerId && id) {
        getComstomerUnitDetails();
      } else if (id) {
        getEquipmentDetails();
      }
    }
  };

  useEffect(() => {
    getCustomerEquipmentDetails();
  }, [id, stateData, canUpdateUnitDetails, canCustomerlistPermission]);

  let childRefreshFunction: () => void;

  const setChildRefreshFunction = (refreshFunc: () => void) => {
    childRefreshFunction = refreshFunc;
  };

  const handleRefreshClick = () => {
    if (childRefreshFunction) {
      childRefreshFunction(); // Trigger the child component's refresh function
    }
    getCustomerEquipmentDetails();
    setRefreshKey((prevKey) => prevKey + 1);
  };
  useEffect(() => {
    setRefreshFunction(handleRefreshClick);
  }, [setRefreshFunction]);

  useEffect(() => {
    sessionStorage.removeItem('paramPayload');
  }, []);
  return (
    <>
      {!canUpdateUnitDetails || !canCustomerlistPermission ? (
        <Unauthorized requiredAccess={requiredAccess} />
      ) : (
        <>
          <section className="customer_management_name-edit">
            <div className="customer_management_name-edit-customer">
              <h5>
                {' '}
                {customerUnitDetails?.firstName && customerUnitDetails?.lastName
                  ? `${customerUnitDetails.firstName} ${customerUnitDetails.lastName}`
                  : ' '}
              </h5>{' '}
              <div className="customer_management_name-edit-address customer_management_name-equipment_details ">
                <div className="customer_management_name-edit-address-profile">
                  <img src={userProfile} alt="customer" />
                </div>

                <div>
                  <div className="customer_management_name-edit-address-contact">
                    <div className="customer_management_name-edit-address-contact-img">
                      <img
                        src={CustomerCall}
                        width="24px"
                        height="24px"
                        alt="CustomerCall"
                      />{' '}
                      <h6>{customerUnitDetails?.mobileNo || ' '}</h6>
                    </div>
                    <div className="customer_management_name-edit-address-contact-img">
                      <img
                        src={CustomerSms}
                        width="24px"
                        height="24px"
                        alt="CustomerSms"
                      />{' '}
                      <h6>{customerUnitDetails?.email || ' '}</h6>
                    </div>
                  </div>
                  <div className="customer_management_name-edit-address-contact-img">
                    <img
                      src={CustomerLocation}
                      width="24px"
                      height="24px"
                      alt="CustomerLocation"
                    />{' '}
                    <h6>
                      {`${customerUnitDetails?.address || ''} ${customerUnitDetails?.state || ''} ${customerUnitDetails?.country || ''}`}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <EquipmentInformation equipmentDetailsData={customerUnitDetails} />

          <ReadableParameterList
            equipmentDetailsData={customerUnitDetails}
            setRefreshFunction={setChildRefreshFunction}
            collapseView={collapseView}
          />
          <WritableParameterList
            equipmentDetailsData={customerUnitDetails}
            equipmentPage="ownedEquipment"
            refreshKey={refreshKey}
          />

          <EquipmentAlert
            equipmentDetailsData={customerUnitDetails}
            refreshKey={refreshKey}
          />
        </>
      )}
    </>
  );
};

export default EquipmentDetails;
